import { Datatable, SearchHeader, SubHeader } from "../../../../common";
import { deleteBrand, getBrands } from "../../../../../api";
import { useLanguage } from "../../../../../context";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../../Libraries";
import { useEffect, useState } from "react";

const BrandList = () => {

    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        resultsPerPage: 10,
        totalCount: 0,
        page: 1,
    });

    useEffect(() => {
        handleBrands();
    }, []);

    const onDelete = async (id) => {
        try {
            const data = await deleteBrand(id, { archive: true });
            if (data.success) handleBrands();
        } catch (err) { }
    };

    const handleBrands = async (reqPage = 1, filters = undefined) => {
        try {
            setLoading(true);

            let params = {
                resultsPerPage: pagination.resultsPerPage,
                page: reqPage
            };

            if (filters) params = { ...params, ...filters };

            const { data } = await getBrands(params);
            const { resultsPerPage, totalCount, brands, page } = data || {};

            setPagination({ resultsPerPage, totalCount, page });
            setList(brands.map(brand => {
                return {
                    nameLocal: brand.nameLocal || '',
                    category: brand?.category || '',
                    isActive: brand.isActive || '',
                    createdAt: brand.createdAt,
                    name: brand.name || '',
                    image: brand.image,
                    _id: brand._id,
                }
            }));

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (page) => {
        if (page == pagination.current || loading) return;
        handleBrands(page);
    };

    const AddBrand = () => navigate('/brand/create');
    const ImportBrand = () => { };

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        subTitle: 'manage_ur_brands',
                        title: 'brand_list',
                        overlays: [
                            {
                                svg: 'assets/img/icons/pdf.svg',
                                tipType: I18n.pdf
                            },
                            {
                                svg: 'assets/img/icons/excel.svg',
                                tipType: I18n.excel
                            },
                            {
                                Icon: Icon['referesh'],
                                onClick: handleBrands,
                                tipType: I18n.refresh,
                                disabled: loading
                            }
                        ],
                        actions: [
                            {
                                className: 'btn btn-added',
                                title: 'add_new_brand',
                                action: AddBrand,
                                icon: 'plus',

                            },
                            {
                                className: 'btn btn-added color',
                                title: 'import_brand',
                                action: ImportBrand,
                                icon: 'download',
                            }
                        ],
                    }}
                />

                <div className="card table-list-card">
                    <div className="card-body">
                        <SearchHeader applyFilter={handleBrands} />

                        <div className="table-responsive">
                            <Datatable
                                onPageChange={onPageChange}
                                pagination={pagination}
                                onDelete={onDelete}
                                loading={loading}
                                dataSource={list}
                                noOfColumns={4}
                                type="brand"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandList;